module.exports = "/assets/7b6480563054ed7f4f9c5ccdacaa6563.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/DD.png
// module id = 1297
// module chunks = 0